import React from 'react';
import { coverage, solutionMetrics } from '../data/salesCopy';
export function SolutionSection() {
  return <section className="w-full bg-ink text-paper" data-id="element-212" data-mp="3aakmnujy98as">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-5 sm:py-16 lg:py-24" data-id="element-213" data-mp="3abvovpxqy7zs">
        <div className="max-w-3xl" data-id="element-214" data-mp="3oalopdbyalru">
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-rust-soft sm:text-xs" data-id="element-215" data-mp="3jah5hfjnrcxx">
            The most complete system for piano and guitar teachers
          </p>
          <h2 className="mt-3 font-display text-3xl font-semibold leading-[1.05] tracking-tight sm:mt-4 sm:text-5xl" data-id="element-216" data-mp="1289ca1i5oz5">
            TeachersKit™
          </h2>
          <p className="mt-3 font-display text-lg font-medium leading-snug text-paper/80 sm:mt-4 sm:text-2xl" data-id="element-217" data-mp="at2vzfinuql4">
            The 6-volume “Anti-Abandonment” teaching system.
          </p>
          <p className="mt-5 text-[15px] leading-relaxed text-paper/75 sm:mt-6 sm:text-lg" data-id="element-218" data-mp="ktmx8i66jv3c">
            Over 300 pages of complete lesson plans, professional exercises, reading games,
            technique guides, and studio management tools. It’s not a theory book — it’s a
            professional toolbox, already prepared for you.
          </p>
          <p className="mt-4 text-[15px] font-medium leading-relaxed text-paper/90 sm:text-base" data-id="element-219" data-mp="3bbjs4fo1kmdd">
            Everything is delivered as print-ready PDF files sent to your email. No videos, no
            audiobooks, no platform to log into.
          </p>
        </div>

        <dl className="mt-10 grid grid-cols-2 gap-6 border-t border-paper/15 pt-7 sm:mt-12 sm:gap-8 sm:pt-8 md:grid-cols-4" data-id="element-220" data-mp="3p8yknt9lda9k">
          {solutionMetrics.map(metric => <div key={metric.label} data-id="element-221" data-mp="2uyfmow7bb5i">
              <dt className="text-[11px] font-medium uppercase tracking-[0.12em] text-paper/55 sm:text-xs" data-id="element-222" data-mp="2uox1mdhk69u">
                {metric.label}
              </dt>
              <dd className="mt-2 font-display text-2xl font-semibold leading-none sm:text-4xl" data-id="element-223" data-mp="bvd602o0vgfv">
                {metric.value}
              </dd>
            </div>)}
        </dl>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:mt-16 sm:gap-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16" data-id="element-224" data-mp="2cw9t8newe2zd">
          <div data-id="element-225" data-mp="27yrkoy4slprw">
            <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-rust-soft sm:text-xs" data-id="element-226" data-mp="27z1fcz0s8l3x">
              Total coverage
            </p>
            <h3 className="mt-3 font-display text-xl font-semibold leading-tight sm:text-3xl" data-id="element-227" data-mp="2hw60qwmt0cjo">
              Beginner through advanced · Kids, teens and adults
            </h3>
          </div>
          <ul className="grid grid-cols-1 gap-x-10 sm:grid-cols-2" data-id="element-228" data-mp="2rlpj816lu4e0">
            {coverage.map(item => <li key={item.number} className="flex items-baseline gap-4 border-b border-paper/12 py-3.5 sm:py-4" data-id="element-229" data-mp="35l8ehtebhl8w">
                <span className="font-display text-sm font-semibold text-rust-soft" data-id="element-230" data-mp="30n70vnznue4t">
                  {item.number}
                </span>
                <span className="text-[15px] font-medium text-paper/90" data-id="element-231" data-mp="168mjplajt0q6">{item.label}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}